import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection } from "rxdb-hooks";

export const RXDB_NOTIFICATION_PREFERENCE_COLLECTION_NAME =
  "notification-preference";

export const useRxCollectionNotificationPreference =
  (): RxCollection<NotificationPreference> | null =>
    useRxCollection<NotificationPreference>(
      RXDB_NOTIFICATION_PREFERENCE_COLLECTION_NAME,
    );

const NOTIFICATION_PREFERENCE_SCHEMA_LITERAL = {
  title: "notification preference schema",
  version: 1,
  description:
    "Local-only per-(user, category) enabled toggle for INFO-severity notifications",
  type: "object",
  primaryKey: {
    key: "id",
    fields: ["userId", "categoryKey"],
    separator: "|",
  },
  properties: {
    id: {
      // userId (100) + "|" (1) + categoryKey (100) = up to 201. Bumped to 250
      // to leave headroom and avoid rejecting valid composite keys at the limit.
      type: "string",
      maxLength: 250,
    },
    userId: {
      type: "string",
      maxLength: 100,
    },
    categoryKey: {
      type: "string",
      maxLength: 100,
    },
    enabled: {
      type: "boolean",
    },
  },
  required: ["id", "userId", "categoryKey", "enabled"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(NOTIFICATION_PREFERENCE_SCHEMA_LITERAL);

export type NotificationPreference = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const NOTIFICATION_PREFERENCE_SCHEMA: RxJsonSchema<NotificationPreference> =
  NOTIFICATION_PREFERENCE_SCHEMA_LITERAL;
